import { render, staticRenderFns } from "./ImeiIoComponent.vue?vue&type=template&id=5b1384b6&scoped=true&"
import script from "./ImeiIoComponent.vue?vue&type=script&lang=js&"
export * from "./ImeiIoComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImeiIoComponent.vue?vue&type=style&index=0&id=5b1384b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1384b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemGroup,VListItemSubtitle,VListItemTitle})
